/**
 * web/src/hooks/queries/useTrackedEmails.ts
 * Tracked emails for an event (default: all statuses). The Confirmations page
 * reads this and filters by status client-side; the WS handler + mark-confirmed
 * mutation reconcile against the broad `qk.trackedEmails.root()` prefix so they
 * reach this list regardless of the active status filter (F12).
 */
import { useQuery } from '@tanstack/react-query';
import { listTrackedEmails, type ListTrackedEmailsQuery } from '../../api/tracked-emails';
import { qk } from '../../lib/queryKeys';

/**
 * Generic tracked-email list. Pass `eventId` / `status` / `workflowId` to narrow.
 *
 * @param q optional filters (eventId / status / workflowId)
 * @param opts.enabled gate the fetch (GateReview only fetches once a step is done)
 * @returns React Query result for TrackedEmail[]
 * @sideEffects HTTP GET
 * @idempotent yes
 */
export function useTrackedEmails(q: ListTrackedEmailsQuery = {}, opts: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: qk.trackedEmails.list(q),
    queryFn: () => listTrackedEmails(q),
    enabled: opts.enabled ?? true,
  });
}
